module.exports = __webpack_public_path__ + "static/media/autokar (9).c1e10771.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar (9).jpg
// module id = 847
// module chunks = 0